import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckCircle,
  faExclamationCircle,
  faInfoCircle,
  faQuestionCircle,
  faTriangleExclamation
} from '@fortawesome/free-solid-svg-icons';

const MODAL_CONFIG = {
  success: {
    icon: faCheckCircle,
    titleFallback: 'Success',
    confirmClassName: 'btn btn-primary'
  },
  error: {
    icon: faExclamationCircle,
    titleFallback: 'Error',
    confirmClassName: 'btn btn-primary'
  },
  warning: {
    icon: faTriangleExclamation,
    titleFallback: 'Warning',
    confirmClassName: 'btn btn-primary'
  },
  info: {
    icon: faInfoCircle,
    titleFallback: 'Information',
    confirmClassName: 'btn btn-primary'
  },
  confirm: {
    icon: faQuestionCircle,
    titleFallback: 'Confirm',
    confirmClassName: 'btn btn-danger'
  }
};

const FeedbackModal = ({
  isOpen,
  type = 'info',
  icon = null,
  title = '',
  message = '',
  confirmText = 'OK',
  cancelText = 'Cancel',
  showCancel = false,
  showCloseButton = true,
  isProcessing = false,
  autoClose = 0,
  onConfirm,
  onClose
}) => {
  useEffect(() => {
    if (!isOpen || autoClose <= 0 || !onClose) return undefined;
    const timer = window.setTimeout(() => {
      onClose();
    }, autoClose);
    return () => window.clearTimeout(timer);
  }, [isOpen, autoClose, onClose]);

  if (!isOpen) return null;

  const config = MODAL_CONFIG[type] || MODAL_CONFIG.info;
  const resolvedTitle = title || config.titleFallback;
  const resolvedIcon = icon || config.icon;
  const handleConfirm = onConfirm || onClose;

  return (
    <div className="modal-overlay feedback-modal-overlay" onClick={onClose}>
      <div
        className={`modal-content modern-modal feedback-modal feedback-modal-${type}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header feedback-modal-header">
          <div className="modal-header-content">
            <div className="modal-header-icon feedback-modal-icon">
              <FontAwesomeIcon icon={resolvedIcon} />
            </div>
            <h3>{resolvedTitle}</h3>
          </div>
          {showCloseButton && (
            <button
              className="close-button"
              onClick={onClose}
              type="button"
              aria-label="Close"
            >
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
          )}
        </div>

        <div className="modal-body feedback-modal-body">
          <p className="feedback-message">{message}</p>
        </div>

        <div className="confirm-footer">
          {showCancel && (
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              disabled={isProcessing}
            >
              <i className="fa fa-times" aria-hidden="true"></i> {cancelText}
            </button>
          )}
          <button
            type="button"
            className={config.confirmClassName}
            onClick={handleConfirm}
            disabled={isProcessing}
          >
            <i className="fa fa-check" aria-hidden="true"></i> {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeedbackModal;
